import type { ReactElement, ReactNode } from 'react';

export function AccountContainer({
  children,
}: {
  children: ReactNode;
}): ReactElement {
  return <div className="mx-auto my-0 w-full sm:w-[66.66667%]">{children}</div>;
}
